import { Button } from "@shared/ui/button";
import { Send } from "lucide-react";
import React, { useState } from "react";
import TestSendCommunication from "./testSendModal";

const PreviewTemplate = ({ form, audienceLabel, signatureLabel, categoryLabel }) => {
  if (!form) return null;
  console.log('debug sign', signatureLabel)
  const channel = form.watch("channel");
  const templateName = form.watch("templateName");
  const subject = form.watch("subject");
  const emailFormat = form.watch("emailFormat");
  const emailBody = form.watch("emailBody");
  const richTextBody = form.watch("richTextBody");
  const htmlTextBody = form.watch("htmlTextBody");
  const footer = form.watch("footer");
  const signature = form.watch("signature");
  const message = form.watch("message");

  const noChannelSelected = !channel && channel !== 0;
  const [sendDialogOpen, setSendDialogOpen] = useState(false);

  // Get the email content based on format
  const getEmailContent = () => {
  switch (emailFormat) {
    case "plain_text":
      return emailBody;
    case "rich_text":
      return richTextBody;
    case "html":
      return htmlTextBody;
    default:
      return emailBody;
  }
};

const content = getEmailContent();
console.log("htmlTextBody:", htmlTextBody);
  // Clean HTML for preview
  const decodeAndCleanHTML = (html) => {
    if (!html) return "";

    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    let decoded = txt.value;

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    return tempDiv.textContent || tempDiv.innerText || "";
  };

  // Render content (NO PLACEHOLDER REPLACEMENT)
  const renderContent = () => {
  switch (emailFormat) {
    case "plain_text":
      return (
        <div className="whitespace-pre-wrap text-sm leading-relaxed">
          {content}
        </div>
      );

    case "rich_text":
      // richTextBody is already HTML markup from the rich text editor
      return (
        <div
          className="text-sm leading-relaxed [&_p]:mb-2 [&_strong]:font-bold [&_em]:italic [&_h1]:text-2xl [&_h1]:font-bold [&_h2]:text-xl [&_h2]:font-bold [&_h3]:text-lg [&_h3]:font-bold [&_ul]:list-disc [&_ul]:ml-4 [&_ol]:list-decimal [&_ol]:ml-4 [&_li]:mb-1 [&_a]:text-blue-600 [&_a]:underline"
          dangerouslySetInnerHTML={{ __html: content || "" }}
        />
      );

    case "html": {
  // Normalize: wrap bare HTML snippets in a full document so the iframe renders correctly.
  // If the content already contains <html> or <!DOCTYPE …>, use it as-is.
  const isFullDocument = /<!doctype|<html/i.test(content || "");
  const srcDoc = isFullDocument
    ? content
    : `<!DOCTYPE html>
<html>
  <head>
    <meta charset="UTF-8" />
    <style>
      body { margin: 0; padding: 8px; font-family: sans-serif; font-size: 14px; line-height: 1.6; color: #333; }
    </style>
  </head>
  <body>${content || ""}</body>
</html>`;

  return (
    <iframe
      key={srcDoc} // remount when content changes so onLoad fires reliably
      srcDoc={srcDoc}
      title="HTML Preview"
      className="w-full border-0 rounded"
      style={{ minHeight: 120 }}
      sandbox="allow-same-origin"
      onLoad={(e) => {
        const iframe = e.currentTarget;
        const doc = iframe.contentDocument;
        if (doc?.body) {
          iframe.style.height = doc.body.scrollHeight + 16 + "px";
        }
      }}
    />
  );
}

    default:
      return (
        <div className="whitespace-pre-wrap text-sm leading-relaxed">
          {content}
        </div>
      );
  }
};

  return (
    <div className="space-y-6 h-full overflow-y-auto">
      {/* Header */}
      <div className="flex items-center justify-between sticky top-0 bg-white z-10 pb-4 border-b">
        <h2 className="text-lg font-bold tracking-tight">Live Preview</h2>

        {/* <Button size="sm" onClick={() => setSendDialogOpen(true)}>
          <Send className="h-4 w-4 mr-2" />
          Test Send
        </Button> */}
      </div>

      {noChannelSelected ? (
        <div className="flex items-center justify-center h-[400px] text-gray-500">
          <p>Select a channel to see preview</p>
        </div>
      ) : (
        <>
          <TestSendCommunication
            open={sendDialogOpen}
            onOpenChange={setSendDialogOpen}
            source="template"
            templateName={templateName}
            onSend={(payload) => console.log("Test send:", payload)}
          />

          {/* Template Info */}
          <div className="space-y-1">
            <div className="text-sm text-gray-500">Template Name</div>
            <div className="text-base font-semibold">
              {templateName || "Untitled Template"}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8">
            <div className="space-y-1">
              <div className="text-sm text-gray-500">Category</div>
              <div className="text-base font-medium">{categoryLabel || "—"}</div>
            </div>
            <div className="space-y-1">
              <div className="text-sm text-gray-500">Audience</div>
              <div className="text-base font-medium">
                {audienceLabel || "—"}
              </div>
            </div>
          </div>

          <div className="border-t pt-6">
            {/* EMAIL CHANNEL */}
            {channel === "0" && (
              <div className="space-y-4">
                {/* Subject */}
                <div className="space-y-2">
                  <div className="text-sm font-medium">Subject:</div>
                  <div className="text-base">{subject || "No subject"}</div>
                </div>

                <div className="border-t pt-4">
                  {content ? (
                    <div className="space-y-4">
                      {renderContent()}

                      {/* Footer */}
                      {footer && (
                        <div className="border-t pt-4 mt-6">
                          <div className="text-sm text-gray-600 whitespace-pre-wrap">
                            {footer}
                          </div>
                        </div>
                      )}

                      {/* Signature */}
                      {signature && signatureLabel && (
                        <div className="text-sm text-gray-700 mt-4">
                          <div
                          className="font-medium"
                          dangerouslySetInnerHTML={{ __html: signatureLabel }}
                        />
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="text-sm text-gray-500">
                      Email body content will appear here
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* SMS CHANNEL */}
            {channel === "1" && (
              <div className="space-y-4">
                {/* Message bubble */}
                <div className="max-w-sm">
                  <div className="bg-primary text-primary-foreground rounded-2xl rounded-bl-sm p-4 shadow-sm inline-block max-w-full">
                    <div className="text-base leading-relaxed break-words">
                      {message || "Message preview will appear here"}
                    </div>
                  </div>
                </div>

                <div className="text-sm text-gray-500">Text message Preview</div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default PreviewTemplate;